import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Dashboard } from '../../dashborad/Dashboard';
import { useMyContext } from '../../../../context/MyContext';
import { FiLock, FiLink, FiExternalLink, FiCheck, FiAlertCircle, FiRefreshCw } from 'react-icons/fi';
import { Base_Url, woocomAuth, woocomStatus } from '../../../../config/config'; // Add woocomStatus in config
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import {
    Package,
    Users,
    TrendingUp,
    AlertCircle
  } from "lucide-react";
  
  import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer
  } from "recharts";


export default function WooCommerceConnect() {
    const { isDarkMode } = useMyContext();

    // States
    const [storeUrl, setStoreUrl] = useState('');
    const [touched, setTouched] = useState(false);
    const [fieldError, setFieldError] = useState('');
    const [hint, setHint] = useState('');
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(''); // 'connected', 'not_connected', 'pending', etc.
    const [statusMessage, setStatusMessage] = useState('');
    const [connectedStore, setConnectedStore] = useState(null);

    const isValidUrl = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
        } catch {
            return false;
        }
    };

    // Fetch Connection Status
    // const checkConnectionStatus = async () => {
    //     try {
    //         setLoading(true);
    //         const cus_id = localStorage.getItem("cus_id");
    //         const token = localStorage.getItem("token");

    //         const response = await axios.get(
    //             `${Base_Url}${woocomStatus}`,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     cus_id: cus_id,
    //                     token: token,
    //                 },
    //             }
    //         );

    //         const data = response.data;

    //         if (data?.status === 'connected') {
    //             setStatus('connected');
    //             setConnectedStore(data.store || data.data?.store);
    //         }
    //         else if (data?.status === 'pending') {
    //             setStatus('pending');
    //             setStatusMessage(data.message || 'Your connection request is pending approval. Please contact admin.');
    //         }
    //         else {
    //             setStatus('not_connected');
    //         }
    //     } catch (error) {
    //         console.error("Status Check Error:", error);
    //         setStatus('not_connected'); // Default to connect form on error
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const navigate = useNavigate();
    const checkConnectionStatus = async () => {
        try {
            setLoading(true);
    
            const cus_id = localStorage.getItem("cus_id");
            const token = localStorage.getItem("token");
    
            const response = await axios({
                method: "GET",
                url: `${Base_Url}/integration/woocommerce/Checkstatus/${cus_id}`,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "cus_id": cus_id,
                    "token": token
                },
                data: {}
            });
    
            const data = response.data;
    
            console.log(data);
    
            if (data?.success && data?.status === "connected") {
                setStatus("connected");
                setConnectedStore(data.store);
            } else if (data?.status === "pending") {
                setStatus("pending");
                setStatusMessage(data.message);
            } else {
                setStatus("not_connected");
            }
    
        } catch (error) {
            console.log(error.response?.data || error);
            setStatus("not_connected");
        } finally {
            setLoading(false);
        }
    };
    // const checkConnectionStatus = async () => {
    //     try {
    //         setLoading(true);

    //         // ==================== MOCK / STATIC RESPONSES (Testing Purpose) ====================
    //         // Aap inme se kisi ek ko uncomment karke test kar sakte ho

    //         // Mock Response 1: Connected
    //         const mockData = {
    //             success: true,
    //             status: "connected",
    //             message: "Store is successfully connected",
    //             store: {
    //                 store_url: "https://demostore.com",
    //                 store_name: "Demo WooCommerce Store",
    //                 connected_at: "2026-04-03T12:00:00Z"
    //             }
    //         };

    //         // Mock Response 2: Pending (uncomment karne ke liye neeche wali lines uncomment karo)
    //         // const mockData = {
    //         //     success: true,
    //         //     status: "pending",
    //         //     message: "Your connection request is pending approval from admin. Please contact admin to approve it."
    //         // };

    //         // Mock Response 3: Not Connected (default - already not connected dikhega)
    //         // const mockData = {
    //         //     success: true,
    //         //     status: "not_connected",
    //         //     message: "No store connected yet"
    //         // };   

    //         // Simulate network delay (real feel ke liye)
    //         await new Promise(resolve => setTimeout(resolve, 1000));

    //         const data = mockData;   // ← Yahan mockData use ho raha hai

    //         // ==================== REAL API CALL (Comment kar do jab mock use kar rahe ho) ====================
    //         // const cus_id = localStorage.getItem("cus_id");
    //         // const token = localStorage.getItem("token");

    //         // const response = await axios.get(
    //         //     `${Base_Url}${woocomStatus}`,
    //         //     {
    //         //         headers: {
    //         //             "Content-Type": "application/json",
    //         //             cus_id: cus_id,
    //         //             token: token,
    //         //         },
    //         //     }
    //         // );
    //         // const data = response.data;

    //         // =====================================================================================

    //         if (data?.status === 'connected') {
    //             setStatus('connected');
    //             setConnectedStore(data.store || data.data?.store);
    //         }
    //         else if (data?.status === 'pending') {
    //             setStatus('pending');
    //             setStatusMessage(data.message || 'Your connection request is pending approval. Please contact admin.');
    //         }
    //         else {
    //             setStatus('not_connected');
    //         }

    //     } catch (error) {
    //         console.error("Status Check Error:", error);
    //         setStatus('not_connected');
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    useEffect(() => {
        checkConnectionStatus();
    }, []);

    const handleUrlChange = (e) => {
        const value = e.target.value.trim();
        setStoreUrl(value);

        if (value && !isValidUrl(value)) {
            setFieldError('Please enter a valid URL starting with http:// or https://');
            setHint('');
        } else if (value && isValidUrl(value)) {
            setFieldError('');
            setHint('Looks good! Click Connect to proceed.');
        } else {
            setFieldError('');
            setHint('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isValidUrl(storeUrl)) return;

        try {
            const cus_id = localStorage.getItem("cus_id");
            const token = localStorage.getItem("token");

            const payload = {
                store_url: storeUrl,
                vendor_id: cus_id,
            };

            const response = await axios.post(
                Base_Url + woocomAuth,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        cus_id: cus_id,
                        token: token,
                    },
                }
            );

            if (response.data?.status) {
                const url = response.data.auth_url;
                if (url) {
                    const width = 500;
                    const height = 600;
                    const left = window.screenX + (window.innerWidth - width) / 2;
                    const top = window.screenY + (window.innerHeight - height) / 2;

                    const popup = window.open(
                        url,
                        "WooCommerceAuth",
                        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
                    );

                    const timer = setInterval(() => {
                        if (popup.closed) {
                            clearInterval(timer);
                            checkConnectionStatus(); // Re-check status after popup closes
                        }
                    }, 800);
                }
            }
        } catch (error) {
            console.error("API Error:", error.response?.data || error.message);
            alert("Failed to connect. Please try again.");
        }
    };

    // ==================== UI RENDERING ====================

    if (loading) {
        return (
            <div className={`h-screen flex items-center justify-center ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="flex flex-col items-center gap-4">
                    <FiRefreshCw className="animate-spin text-purple-600" size={40} />
                    <p className="text-white-600">Checking connection status...</p>
                </div>
            </div>
        );
    }


    if (status === 'connected') {
        return (
          <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      
            <div className="bg-white-50 p-6">
                <div className="max-w-7xl mx-auto">
      
                  <div className="flex justify-between items-center mb-8">
                    <div>
                      <h1 className="text-3xl font-bold text-white-900">Overview</h1>
                      <p className="text-white-500 mt-1">
                        Welcome back, analyze your dispatch data today.
                      </p>
                    </div>
      
                    <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-200 shadow-sm">
                      <FiRefreshCw className="w-5 h-5" />
                      Sync Orders
                    </button>
                  </div>
      
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      
                    <div className="bg-white rounded-2xl p-6 shadow-sm border border-white-100">
                      <div className="flex items-center justify-between">
                        <div className="p-3 bg-blue-100 rounded-xl">
                          <Package className="w-8 h-8 text-blue-600" />
                        </div>
                        <span className="text-emerald-500 text-sm font-medium">+12.5%</span>
                      </div>
                      <div className="mt-6">
                        <p className="text-white-500 text-sm">Total Orders</p>
                        <p className="text-4xl font-semibold text-white-900 mt-2">12,450</p>
                      </div>
                    </div>
      
                    <div className="bg-white rounded-2xl p-6 shadow-sm border border-white-100">
                      <div className="flex items-center justify-between">
                        <div className="p-3 bg-purple-100 rounded-xl">
                          <Users className="w-8 h-8 text-purple-600" />
                        </div>
                        <span className="text-emerald-500 text-sm font-medium">+4.2%</span>
                      </div>
                      <div className="mt-6">
                        <p className="text-white-500 text-sm">Customers</p>
                        <p className="text-4xl font-semibold text-white-900 mt-2">342</p>
                      </div>
                    </div>
      
                    <div className="bg-white rounded-2xl p-6 shadow-sm border border-white-100">
                      <div className="flex items-center justify-between">
                        <div className="p-3 bg-emerald-100 rounded-xl">
                          <TrendingUp className="w-8 h-8 text-emerald-600" />
                        </div>
                        <span className="text-emerald-500 text-sm font-medium">+1.4%</span>
                      </div>
                      <div className="mt-6">
                        <p className="text-white-500 text-sm">Revenue Growth</p>
                        <p className="text-4xl font-semibold text-white-900 mt-2">98.2%</p>
                      </div>
                    </div>
      
                    <div className="bg-white rounded-2xl p-6 shadow-sm border border-white-100">
                      <div className="flex items-center justify-between">
                        <div className="p-3 bg-orange-100 rounded-xl">
                          <AlertCircle className="w-8 h-8 text-orange-600" />
                        </div>
                        <span className="text-red-500 text-sm font-medium">-2.4%</span>
                      </div>
                      <div className="mt-6">
                        <p className="text-white-500 text-sm">Issues</p>
                        <p className="text-4xl font-semibold text-white-900 mt-2">14</p>
                      </div>
                    </div>
      
                  </div>
      
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      
                    <div className="lg:col-span-2 bg-white rounded-3xl p-8 shadow-sm border border-white-100">
                      <h2 className="text-xl font-semibold text-white-900 mb-6">
                        Revenue & Orders Overview
                      </h2>
      
                      <div className="h-96">
                        <ResponsiveContainer width="100%" height="100%">
                          <LineChart data={[
                            { name: "Mon", orders: 400 },
                            { name: "Tue", orders: 300 },
                            { name: "Wed", orders: 500 },
                            { name: "Thu", orders: 200 },
                            { name: "Fri", orders: 700 }
                          ]}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Line type="monotone" dataKey="orders" stroke="#2563eb" strokeWidth={3} />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
      
                    <div className="bg-white rounded-3xl p-8 shadow-sm border border-white-100">
                      <h2 className="text-xl font-semibold text-white-900 mb-6">
                        Recent Activity
                      </h2>
      
                      <div className="space-y-6">
                        <div>🛍️ New Order Received</div>
                        <div>📦 Order Shipped</div>
                        <div>🚚 Delivery Completed</div>
                      </div>
      
                      <button className="mt-8 w-full py-3 border border-white-300 rounded-2xl text-white-700 hover:bg-white-50">
                        View All
                      </button>
                    </div>
      
                  </div>
      
                </div>
              </div>
      
          </div>
        );
      }
    // ===================== PENDING VIEW =====================
    if (status === 'pending') {
        return (
            <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="flex items-center justify-center p-6">
                    <motion.div
                        className="max-w-md w-full bg-white border border-amber-200 rounded-3xl p-8 shadow-xl text-center"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <FiAlertCircle className="mx-auto text-amber-500" size={60} />
                        <h2 className="text-2xl font-bold mt-6 text-white-900">Connection Pending</h2>
                        <p className="mt-4 text-white-600 leading-relaxed">{statusMessage}</p>

                        <div className="mt-8 p-4 bg-amber-50 border border-amber-100 rounded-2xl text-left text-sm">
                            <p className="font-medium text-amber-700">What to do next?</p>
                            <p className="text-amber-600 mt-2">Please contact the administrator to approve your connection request.</p>
                        </div>

                        <button
                            onClick={checkConnectionStatus}
                            className="mt-6 w-full py-3 border border-white-300 rounded-2xl font-medium hover:bg-white-50"
                        >
                            Refresh Status
                        </button>
                    </motion.div>
                </div>
            </div>
        );
    }

    // ===================== DEFAULT: CONNECT FORM (Not Connected) =====================
    return (
        <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="relative flex items-center justify-center bg-white p-3 sm:p-4 md:p-6 lg:p-8 overflow-hidden">
                {/* Purple glow background */}
                <div className="pointer-events-none absolute flex items-center justify-center">
                    <div className="text-[8rem] sm:text-[12rem] md:text-[16rem] lg:text-[20rem] font-black opacity-[0.02] select-none text-purple-900">PX</div>
                </div>

                {/* Improved animated radiant blobs */}
                <div className="pointer-events-none absolute inset-0">
                    <div className="absolute -top-20 sm:-top-32 md:-top-40 -left-16 sm:-left-24 md:-left-32 h-40 w-40 sm:h-56 sm:w-56 md:h-72 md:w-72 rounded-full bg-white blur-2xl sm:blur-3xl animate-pulse" />
                    <div className="absolute -bottom-20 sm:-bottom-32 md:-bottom-40 -right-16 sm:-right-24 md:-right-32 h-48 w-48 sm:h-64 sm:w-64 md:h-80 md:w-80 rounded-full bg-white blur-2xl sm:blur-3xl animate-pulse" style={{ animationDuration: '4s' }} />
                    <div className="absolute top-1/2 -right-20 sm:-right-32 md:-right-40 h-40 w-40 sm:h-52 sm:w-52 md:h-64 md:w-64 rounded-full bg-white blur-[60px] sm:blur-[80px] animate-pulse" style={{ animationDuration: '6s' }} />
                </div>

                <motion.div
                    className="w-full max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 lg:gap-8 items-center"
                    initial={{ opacity: 0, y: 22 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    {/* LEFT INFO CARD */}
                    <motion.div
                        className="relative rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 lg:p-8 shadow-xl sm:shadow-2xl border border-white-200 bg-white"
                        initial={{ x: -40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        <div className="flex items-start gap-2 sm:gap-3">
                            <div className="relative flex-shrink-0">
                                <div className="absolute inset-0 rounded-xl sm:rounded-2xl bg-purple-300/30 blur-lg sm:blur-xl" />
                                <div className="relative h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-purple-100 to-fuchsia-100 border border-purple-200 flex items-center justify-center">
                                    <div className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8 bg-gradient-to-br from-purple-600 to-fuchsia-500 rounded-lg sm:rounded-xl flex items-center justify-center text-white font-bold text-[10px] sm:text-xs">
                                        PX
                                    </div>
                                </div>
                            </div>

                            <div className="flex-1 min-w-0">
                                <h1 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold tracking-tight text-white-900 break-words">
                                    Connect Your WooCommerce Store
                                </h1>
                                <p className="text-[10px] sm:text-xs text-white-600 mt-0.5 sm:mt-1">
                                    Sync orders, automate shipping, and track deliveries with PickupXpress.
                                </p>
                            </div>
                        </div>

                        <div className="mt-3 sm:mt-4 md:mt-5 lg:mt-6 space-y-1.5 sm:space-y-2 md:space-y-3">
                            {[
                                "Enter your WooCommerce store URL.",
                                "Approve secure access on your WordPress admin.",
                                "We auto-sync your WooCommerce orders.",
                                "Ship and track directly from PickupXpress.",
                                "Keep customers updated with real-time tracking.",
                            ].map((step, i) => (
                                <div key={i} className="flex gap-2 sm:gap-3 items-start">
                                    <div className="mt-0.5 flex-shrink-0 h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 rounded-full bg-purple-100 border border-purple-300 flex items-center justify-center text-[10px] sm:text-xs font-semibold text-purple-700">
                                        {i + 1}
                                    </div>
                                    <p className="text-[10px] sm:text-xs text-white-700 leading-relaxed">{step}</p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-3 sm:mt-4 md:mt-5 lg:mt-6 flex items-start sm:items-center gap-2 text-[10px] sm:text-xs text-white-600">
                            <FiLock className="text-purple-600 flex-shrink-0 mt-0.5 sm:mt-0" size={12} />
                            <span>You can revoke access anytime from your WooCommerce store.</span>
                        </div>
                    </motion.div>

                    {/* RIGHT FORM CARD */}
                    <motion.div
                        className="relative rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 lg:p-8 bg-white border border-white-200 shadow-xl sm:shadow-2xl"
                        initial={{ x: 40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}
                    >
                        <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
                            <div>
                                <div className="inline-flex items-center gap-1.5 sm:gap-2 px-2 sm:px-2.5 md:px-3 py-0.5 sm:py-1 rounded-full bg-purple-50 border border-purple-200 text-purple-700 mb-2 sm:mb-3">
                                    <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 bg-purple-100 rounded-full flex items-center justify-center">
                                        <FiLink size={6} className="text-purple-600 sm:w-2 sm:h-2" />
                                    </div>
                                    <span className="text-[9px] sm:text-[10px] md:text-xs">WooCommerce Secure Connect</span>
                                </div>

                                <h2 className="text-sm sm:text-base md:text-lg font-semibold text-white-900">Seller Panel</h2>
                                <p className="text-[10px] sm:text-xs text-white-600 mt-0.5 sm:mt-1">
                                    Enter your WooCommerce URL and follow the approval step.
                                </p>
                            </div>

                            <div className="space-y-1.5 sm:space-y-2">
                                <label className="block text-[9px] sm:text-[10px] md:text-xs font-medium uppercase tracking-wide text-white-600">
                                    Store URL
                                </label>

                                <div className="relative group">
                                    <FiExternalLink className="absolute left-2.5 sm:left-3 top-2 sm:top-2.5 text-white-400 text-xs sm:text-sm" />
                                    <input
                                        type="text"
                                        value={storeUrl}
                                        onChange={handleUrlChange}
                                        onBlur={() => setTouched(true)}
                                        placeholder="https://yourstore.com"
                                        className={`w-full bg-white-50 text-white-900 rounded-xl pl-8 sm:pl-10 pr-8 sm:pr-10 py-1.5 sm:py-2 outline-none border text-[10px] sm:text-xs placeholder:text-white-400 transition-all
                                    ${touched && fieldError
                                                ? "border-red-400 shadow-[0_0_0_1px_rgba(248,113,113,0.7)]"
                                                : touched && isValidUrl(storeUrl)
                                                    ? "border-purple-500 shadow-[0_0_0_1px_rgba(147,51,234,0.5)]"
                                                    : "border-white-300 focus:border-purple-500 focus:shadow-[0_0_0_1px_rgba(147,51,234,0.5)]"
                                            }`}
                                    />

                                    {touched && (
                                        <div className="absolute right-2.5 sm:right-3 top-1.5 sm:top-2">
                                            {isValidUrl(storeUrl) ? (
                                                <FiCheck className="text-purple-600 text-xs sm:text-sm" />
                                            ) : fieldError ? (
                                                <FiAlertCircle className="text-red-500 text-xs sm:text-sm" />
                                            ) : null}
                                        </div>
                                    )}
                                </div>

                                {fieldError && (
                                    <p className="text-[10px] sm:text-xs text-red-600 flex items-center gap-1">
                                        <FiAlertCircle size={10} className="sm:w-3 sm:h-3" /> {fieldError}
                                    </p>
                                )}

                                {!fieldError && hint && (
                                    <p className="text-[10px] sm:text-xs text-purple-600">{hint}</p>
                                )}
                            </div>

                            <motion.button
                                type="button"
                                onClick={handleSubmit}
                                disabled={!isValidUrl(storeUrl)}
                                whileHover={{ scale: isValidUrl(storeUrl) ? 1.02 : 1 }}
                                whileTap={{ scale: isValidUrl(storeUrl) ? 0.97 : 1 }}
                                className="w-full rounded-xl bg-gradient-to-r from-purple-600 via-fuchsia-500 to-purple-600 text-white py-2 sm:py-2.5 text-[10px] sm:text-xs md:text-sm font-semibold flex items-center justify-center gap-1.5 sm:gap-2 shadow-lg disabled:opacity-40 disabled:cursor-not-allowed transition-all hover:shadow-xl"
                            >
                                <FiLink size={12} className="sm:w-3.5 sm:h-3.5" />
                                <span>Connect to WooCommerce</span>
                            </motion.button>

                            <div className="border-t border-white-200 pt-2.5 sm:pt-3 md:pt-4 text-[10px] sm:text-xs text-white-600">
                                <div className="flex items-start sm:items-center gap-1.5 sm:gap-2">
                                    <FiLock className="text-purple-600 flex-shrink-0 mt-0.5 sm:mt-0" size={10} />
                                    <span>PickupXpress never asks for your WordPress password.</span>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
}